var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.explanationExists
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip",
                  value: {
                    title: _vm.$t(
                      "application.messages.clickHereToSeeCalculations"
                    ),
                    placement: "left",
                    boundary: "viewport",
                    disabled: _vm.calculationValue.value === null,
                  },
                  expression:
                    "{\n      title: $t('application.messages.clickHereToSeeCalculations'),\n      placement: 'left',\n      boundary: 'viewport',\n      disabled: calculationValue.value === null\n    }",
                },
                {
                  name: "open-window-popover",
                  rawName: "v-open-window-popover",
                  value: _vm.popoverWindowOptions,
                  expression: "popoverWindowOptions",
                },
              ],
              staticClass: "pr-1 bold clickable text-primary underline",
            },
            [
              _vm._v(_vm._s(_vm.calculationValue.name) + ":\n    "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: {
                        title: _vm.$t(
                          "application.messages.dataNeededForCalculationsNotFound"
                        ),
                        placement: "left",
                        boundary: "viewport",
                        disabled: _vm.calculationValue.value !== null,
                      },
                      expression:
                        "{\n        title: $t('application.messages.dataNeededForCalculationsNotFound'),\n        placement: 'left',\n        boundary: 'viewport',\n        disabled: calculationValue.value !== null\n      }",
                    },
                  ],
                },
                [_vm._v("\n      " + _vm._s(_vm.valueText) + "\n    ")]
              ),
            ]
          )
        : [
            _c("span", { staticClass: "pr-1 text-capitalize" }, [
              _vm._v(" " + _vm._s(_vm.calculationValue.name) + ": "),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: {
                      title: _vm.$t(
                        "application.messages.dataNeededForCalculationsNotFound"
                      ),
                      placement: "left",
                      boundary: "viewport",
                      disabled: _vm.calculationValue.value !== null,
                    },
                    expression:
                      "{\n        title: $t('application.messages.dataNeededForCalculationsNotFound'),\n        placement: 'left',\n        boundary: 'viewport',\n        disabled: calculationValue.value !== null\n      }",
                  },
                ],
              },
              [_vm._v(_vm._s(_vm.valueText))]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }